/* Milano wig matchmaker — progressive enhancement only.
   One job: a staggered reveal of the benefit panels as they enter the viewport
   (same pattern as milano-density-guide.js / milano-toppers-guide.js).
   Nothing on /pages/wig-matchmaker depends on this file — every paragraph is
   real text with JavaScript off, and the Octane AI quiz loads its own script
   independently. This file never touches the quiz.
   Idempotent; theme-editor safe via shopify:section:load. */
(function () {
  'use strict';

  if (window.MilanoMatchmaker) return;
  window.MilanoMatchmaker = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var items = (root || document).querySelectorAll('[data-mmk-reveal]:not(.is-revealed)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    Array.prototype.forEach.call(items, function (el) {
      var index = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--mmk-delay', Math.min(Math.max(index, 0) * 45, 270) + 'ms');
      observer.observe(el);
    });
  }

  document.documentElement.classList.add('mmk-js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveals(document);
    });
  } else {
    initReveals(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
  });
})();
